// extracted by mini-css-extract-plugin
export var chevronIcon = "_4l-2";
export var teamName = "_4l-1";
export var teamSwitcherButton = "_4l-0";